import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="content-loader-container">
      <div className="modern-loader">
        <div className="loader-ring"></div>
        <span className="loader-text">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
